import { AppointmentType } from 'kb-shared';

export const splitToInClinicAndVirtual = (
  appointmentType: AppointmentType
): { virtualAppointment: AppointmentType | null; inClinicAppointment: AppointmentType | null } => {
  if (appointmentType.virtual) {
    return {
      virtualAppointment: appointmentType,
      inClinicAppointment: appointmentType.inClinicOrVirtualEquivalent
    };
  }

  return {
    virtualAppointment: appointmentType.inClinicOrVirtualEquivalent,
    inClinicAppointment: appointmentType
  };
};
